import axios, { AxiosPromise, ResponseType } from 'axios';

export const HEADER_AUTH_TOKEN = 'X-Auth-Token';
export const AUTH_LOGOUT_EVENT = 'auth:logout';

const publicUrlPattern = /\/api\/[^/]+\/public\//; // matches "*/api/*/public/*"

const isApiUrl = (url?: string) => !!url && url.startsWith(apiUrl);
const isPublicUrl = (url?: string) => !!url && publicUrlPattern.test(url);

axios.interceptors.request.use(
  async config => {
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }

    if (isApiUrl(config.url) && !config.headers[HEADER_AUTH_TOKEN]) {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers[HEADER_AUTH_TOKEN] = token;
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => response,
  error => {
    const url: string | undefined = error.config?.url;

    if (error.response?.status === 401 && isApiUrl(url) && !isPublicUrl(url) && localStorage.getItem('authToken')) {
      localStorage.removeItem('authToken');
      window.dispatchEvent(new CustomEvent(AUTH_LOGOUT_EVENT));
    }

    return Promise.reject(error);
  }
);

class ApiService {
  get(url: string, params: any = {}, headers: any = {}, responseType?: ResponseType) {
    return axios({
      method: 'get',
      responseType,
      url,
      headers,
      params,
    });
  }

  post(url: string, params: any = {}, headers: any = {}, data: any = {}, responseType?: ResponseType): AxiosPromise {
    return axios({
      method: 'post',
      responseType,
      url,
      headers,
      params,
      data,
    });
  }

  put(url: string, params: any = {}, headers: any = {}, data: any = {}): AxiosPromise {
    return axios({
      method: 'put',
      url,
      headers,
      params,
      data,
    });
  }

  delete(url: string, params: any = {}, headers: any = {}, data: any = {}): AxiosPromise {
    return axios({
      method: 'delete',
      url,
      headers,
      params,
      data,
    });
  }

  patch(url: string, params: any = {}, headers: any = {}, data: any = {}): AxiosPromise {
    return axios({
      method: 'patch',
      url,
      headers,
      params,
      data,
    });
  }
}

const apiService = new ApiService();

const apiUrl: string = process.env.REACT_APP_API_URL || '';

export { apiService, ApiService, apiUrl };
